module.exports = __webpack_public_path__ + "static/media/HCMM652.8c87454a.jpg";